import { Gift, getGiftById } from "../../../../../services/giftApiService";
import { generateGetURL } from "../../../../../services/mediaApiService";
import { Product, getProduct } from "../../../../../services/productApiService";
import i18n from "i18next";

export const fetchGiftData = async (
  giftId: string,
  setGift: React.Dispatch<React.SetStateAction<Gift | null>>,
  setMediaURL: React.Dispatch<React.SetStateAction<string>>,
  setIsVideo: React.Dispatch<React.SetStateAction<boolean>>,
  setProductDetails: React.Dispatch<
    React.SetStateAction<{ [id: string]: Product }>
  >
) => {
  try {
    const fetchedGift = await getGiftById(giftId);
    setGift(fetchedGift);

    if (fetchedGift.Media) {
      const mediaResponse = await generateGetURL(fetchedGift.Media);
      setMediaURL(mediaResponse.signedURL);
      const videoExtensions = [".mp4", ".mov", ".avi"];
      setIsVideo(videoExtensions.includes(mediaResponse.media.extension));
    }

    const productDetailsMap: { [id: string]: Product } = {};
    await Promise.all(
      fetchedGift.Products.map(async (product) => {
        const productData = await getProduct(product.ID);
        productDetailsMap[product.ID] = productData;
      })
    );
    setProductDetails(productDetailsMap);
  } catch (error) {
    console.error("Error fetching gift data:", error);
  }
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(i18n.language || "en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const ThankYouMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className="mt-6 p-4 border-l-4 border-gray-400">
    <blockquote className="italic text-gray-500">"{message}"</blockquote>
  </div>
);
